var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as actions from './auth.actions';
import { tap, filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AuthTokenService } from '../../services/auth-token.service';
import { Router, ActivatedRoute } from '@angular/router';
// const auth = fireApp.auth();
var AuthEffects = /** @class */ (function () {
    function AuthEffects(actions$, store, authToken, router, route) {
        // auth.onAuthStateChanged(data => {
        //   // console.log('\n\n onAuthStateChanged', data);
        // });
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.authToken = authToken;
        this.router = router;
        this.route = route;
        this.redirectUrl = '/dashboard';
        this.loginUrl = '/login';
        this.login$ = this.actions$.pipe(ofType(actions.AuthActionTypes.LoginAction), tap(function (data) {
            //console.log("LOGIN IRTAMEN OS DAME");
            // auth
            //   .signInWithEmailAndPassword(
            //     data.payload.username,
            //     data.payload.password
            //   )
            //   .catch(this.dispatchError);
        }));
        this.logout$ = this.actions$.pipe(ofType(actions.AuthActionTypes.LogoutAction), tap(function (data) {
            _this.router.navigate(['/auth/login']);
            // auth.signOut();
        }));
        this.signup$ = this.actions$.pipe(ofType(actions.AuthActionTypes.SignupAction), tap(function (data) {
            // auth
            //   .createUserWithEmailAndPassword(
            //     data.payload.username,
            //     data.payload.password
            //   )
            //   .catch(this.dispatchError);
        }));
        this.googleSign$ = this.actions$.pipe(ofType(actions.AuthActionTypes.GoogleSign), tap(function (data) {
            // auth
            //   .signInWithPopup(new fireAuth.GoogleAuthProvider())
            //   .catch(this.dispatchError);
        }));
        this.loginRedirect$ = this.actions$.pipe(ofType(actions.AuthActionTypes.LoginRedirect), tap(function (data) {
            _this.redirectUrl = data.payload || '';
            _this.router.navigate([_this.loginUrl]);
        }));
        this.authRedirect$ = this.actions$.pipe(ofType(actions.AuthActionTypes.AuthTokenPayload), filter(function (_) { return _this.router.url === _this.loginUrl; }), tap(function (data) {
            _this.router.navigate([_this.redirectUrl]);
        }));
        this.authUser$ = this.actions$.pipe(ofType(actions.AuthActionTypes.AuthUserChange), 
        // switchMap((data: any) => data.payload.getIdToken()),
        tap(function (_) { return (_this.authToken.token = _); }), map(function (_) { return _this.authToken.readPayload(_); }), map(function (_) { return new actions.AuthTokenPayload(_); }));
        this.dispatchError = function (err) {
            _this.store.dispatch(new actions.AuthFailure({
                code: err.code,
                message: err.message
            }));
        };
        // auth.onIdTokenChanged(authUser => {
        //   // console.log('\n\n onIdTokenChanged', data);
        //   if (authUser) {
        //     this.store.dispatch(new actions.AuthUserChange(authUser));
        //   } else {
        //     this.authToken.token = null;
        //     this.store.dispatch(new actions.NullToken());
        //   }
        // });
    }
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "login$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "logout$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "signup$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "googleSign$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "loginRedirect$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "authRedirect$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "authUser$", void 0);
    return AuthEffects;
}());
export { AuthEffects };
